import React, { Component } from 'react'
import { saveElement } from 'store/actions/elements'
import pako from 'pako'
import styled from 'styled-components/macro'
import Button from 'components/ui/Button'
import LoadingSpinner from 'components/ui/LoadingSpinner'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { t } from 'ttag'
import PropTypes from 'prop-types'

const ElementSaveModalContainer = styled.div`
  max-width: 250px;
  margin-top: ${props => (props.show ? '10px' : '0')};
  padding: ${props => (props.show ? '10px' : '0')};
  border-radius: 2px;
  background-color: #ffffff;
  border: 1px solid #ddd;
  transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
  overflow: hidden;
  max-height: ${props => (props.show ? '500px' : '0')};
  visibility: ${props => (props.show ? 'visible' : 'hidden')};
  input {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 2px;
    font-size: 10px;
  }
  button {
    margin-top: 10px;
    font-size: 10px;
  }
`
const ElementSaveHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`
const ElementSaveCloseButton = styled.a`
  cursor: pointer;
`
const ElementSaveHeader = styled.h5`
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 10px;
  font-weight: 500;
`
const ElementSaveContainer = styled.div`
  & > div {
    position: relative;
  }
`
const ElementSaveMessage = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-size: 12px;
  margin-top: ${props => (props.show ? '10px' : '0')};
  transition: max-height 1s cubic-bezier(0, 1, 0, 1);
  overflow: hidden;
  max-height: ${props => (props.show ? '500px' : '0')};
  visibility: ${props => (props.show ? 'visible' : 'hidden')};
`
const Input = styled.input`
  margin-right: 5px !important;
`

class ElementSave extends Component {
  constructor(props) {
    super(props)

    this.state = {
      elementTitle: '',
      savingElement: false,
      elementSaveMessage: ''
    }
  }

  async saveElement() {
    const { elementTitle } = this.state
    const { filters, saveElement: saveElementAction, type } = this.props
    const body = {
      title: elementTitle,
      type,
      data: {
        search: filters.selectedFilters,
        hash: btoa(
          pako.deflate(JSON.stringify(filters.selectedFilters.projects), {
            to: 'string'
          })
        )
      }
    }
    if (type === 'map') {
      const { zoom, center, mapTypes, isSidebarVisible } = this.props
      body.data.zoom = zoom
      body.data.center = center
      body.data.map_types = mapTypes
      body.data.window_width = window.innerWidth
      body.data.sidebar = isSidebarVisible
    }
    this.setState({ savingElement: true })
    await saveElementAction(body)
    this.setState({
      savingElement: false,
      elementTitle: '',
      elementSaveMessage: t`Saved successfully`
    })
    setTimeout(() => this.setState({ elementSaveMessage: '' }), 5000)
  }

  render() {
    const {
      show,
      closeElementSave,
      type,
      filters: {
        selectedFilters: {
          projects: { location: locationCriteria }
        }
      }
    } = this.props
    const { elementTitle, savingElement, elementSaveMessage } = this.state

    return (
      <ElementSaveModalContainer show={show}>
        <ElementSaveHeaderContainer>
          <ElementSaveHeader>{t`Save ${type} as an element`}</ElementSaveHeader>
          <ElementSaveCloseButton onClick={closeElementSave}>&times;</ElementSaveCloseButton>
        </ElementSaveHeaderContainer>
        {locationCriteria !== null ? (
          <ElementSaveMessage show>
            {t`
            Projects near you -search can't be saved as a report element.
            Please perform a search using the filters.
            `}
          </ElementSaveMessage>
        ) : (
          <>
            <Input
              value={elementTitle}
              placeholder={t`Title`}
              onChange={({ target }) => this.setState({ elementTitle: target.value })}
            />
            <Button disabled={elementTitle.length <= 0 || savingElement} onClick={this.saveElement}>
              {savingElement ? (
                <ElementSaveContainer>
                  <LoadingSpinner showText>&nbsp;</LoadingSpinner>
                </ElementSaveContainer>
              ) : (
                t`Submit`
              )}
            </Button>
            <ElementSaveMessage show={elementSaveMessage.length > 0}>
              {elementSaveMessage}
            </ElementSaveMessage>
          </>
        )}
      </ElementSaveModalContainer>
    )
  }
}

ElementSave.propTypes = {
  filters: PropTypes.shape({
    selectedFilters: PropTypes.object
  }),
  saveElement: PropTypes.func,
  closeElementSave: PropTypes.func,
  type: PropTypes.string,
  zoom: PropTypes.number,
  isSidebarVisible: PropTypes.bool,
  center: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number
  }),
  show: PropTypes.bool,
  mapTypes: PropTypes.array
}

const mapStateToProps = ({ filters }) => ({
  filters
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      saveElement
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(ElementSave)
